export const SIZES = {
	SMALL: 1,
	MEDIUM: 2,
	LARGE: 3,
};

export const STATUSES = {
	IDLE: 'IDLE',
	LOADING: 'LOADING',
	ERROR: 'ERROR',
	READY: 'READY',
};
